<template>
  <div @click="showModal()" class="simulator d-flex flex-column align-items-center openSans-bold cursor-pointer">
    <img src="../assets/images/picto-calculette.svg" alt="calculatrice">
    <h4>Calculez</h4>
    <p>le montant de votre prêt</p>
    <button>Simulateur</button>
    <b-modal hide-footer centered size="lg" id="simulateur">
      <template #modal-title>
        <span class="font-weight-bold mx-auto">Simulateur</span>
      </template>
      <el-slider id="taux" name="taux" v-model="taux" :min="0" :max="5" :step="0.01" :marks="tauxMarks"
        :format-tooltip="formatTooltipTaux">
      </el-slider>
      <el-slider id="montant" name="montant" v-model="montant" :min="0" :max="2000000" :step="5000"
        :marks="montantMarks" :format-tooltip="formatTooltipMontant">
      </el-slider>
      <el-slider id="duree" name="duree" v-model="duree" :min="0" :max="360" :step="1" :marks="dureeMarks"
        :format-tooltip="formatTooltipDuree">
      </el-slider>
      <p class="font-weight-bold text-center">Mensualités de {{ mensualite }} €</p>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { ModalPlugin } from 'bootstrap-vue'
import { Slider } from 'element-ui'

Vue.use(ModalPlugin)
Vue.use(Slider)

export default {
  name: 'Simulateur',
  data() {
    return {
      taux: null,
      montant: null,
      duree: null,
      tauxMarks: {
        0: {
          style: {
            color: '#49507B'
          },
          label: this.$createElement('small', '0%')
        },
        5: {
          style: {
            color: '#49507B'
          },
          label: this.$createElement('small', '5%')
        }
      },
      montantMarks: {
        0: {
          style: {
            color: '#49507B'
          },
          label: this.$createElement('small', '0 €')
        },
        2000000: {
          style: {
            color: '#49507B'
          },
          label: this.$createElement('small', '2 000 000 €')
        }
      },
      dureeMarks: {
        0: {
          style: {
            color: '#49507B'
          },
          label: this.$createElement('small', '0 mois')
        },
        360: {
          style: {
            color: '#49507B'
          },
          label: this.$createElement('small', '360 mois')
        }
      }
    }
  },
  computed: {
    mensualite: function () {
      const mensualite = Math.round(((this.montant * (this.taux / 100)) / 12) / (1 - Math.pow(1 + ( (this.taux / 100) / 12),  -this.duree)))
      return mensualite
    }
  },
  methods: {
    formatTooltipTaux(value) {
      return value + '%'
    },
    formatTooltipMontant(value) {
      value = parseInt(value)
      if (value < 999) {
        return value + ' €'
      }
      return this.$options.filters.formatMoney(value) + ' €'
    },
    formatTooltipDuree(value) {
      value = parseInt(value)
      return value + ' mois'
    },
    showModal() {
      this.$bvModal.show('simulateur')
    }
  }
}
</script>

<style lang="scss" scoped>
.simulator {
  padding: 24px;

  h4 {
    font-weight: 700;
  }

  button {
    background-color: var(--color-primary);
    color: white;
    height: 50px;
    width: 100%;
    border: none;
    border-radius: 5px;
  }

  .el-slider {
    height: 33px;
    width: 125px;
    margin: 0 5px;

    .el-slider__runway {
      background-color: #ddd;

      .el-slider__bar,
      .el-slider__button {
        background-color: var(--color-primary);
        border: none;
      }
    }

    .el-slider__runway,
    .el-slider__bar {
      height: 4px;
    }

    .el-slider__button {
      height: 16px;
      width: 16px;
    }

    .el-slider__button-wrapper {
      top: -16px;
    }
  }

}

img {
  width: 4rem !important;
  height: 6rem !important;
}

::v-deep .modal-title {
  width: 100% !important;
  text-align: center !important;
}

::v-deep .el-slider:first-of-type {
  margin-top: 3rem !important;
}

::v-deep .el-slider {
  margin-bottom: 3rem !important;
}

::v-deep .el-slider__runway {
  margin: 5px 0 !important;
  bottom: 0 !important;
}

::v-deep .el-slider__marks-text {
  white-space: nowrap !important;
  margin-top: -2rem !important;
}

::v-deep #duree .el-slider__marks-text:first-of-type {
  transform: translateX(-25%) !important;
}

::v-deep .el-slider__marks-text:first-of-type {
  transform: translateX(-50%) !important;
}

::v-deep .el-slider__marks-text:last-of-type {
  transform: translateX(-90%) !important;
}

::v-deep .el-slider__bar {
  background-color: var(--color-primary) !important;
}

::v-deep .el-slider__button {
  border-color: var(--color-primary) !important;
}

.cursor-pointer {
  cursor: pointer !important;

  button {
    cursor: default !important;
  }
}
</style>
